import { useContext } from 'react';

import TourContext from './TourContext';

const useTourContext = () => useContext(TourContext);

export default useTourContext;
